import React from "react";
import { hero } from "../data/content";
import { surface } from "../data/theme";
import { BuyButton } from "./BuyButton";
import { Pill } from "./Pill";
import { ProductMockup } from "./ProductMockup";
import { Punchline } from "./Punchline";
import { SectionTitle } from "./SectionTitle";
import { Wave } from "./Wave";

// Orden en celular: título → mockup → botón → garantía → texto → remate.
// Desde sm: título → texto → remate → mockup → botón → garantía.
export function Hero() {
  return <header className="bg-hero relative flex flex-col overflow-hidden px-5 pb-20 pt-6 text-center sm:px-10 sm:pb-24 sm:pt-12" data-id="element-104" data-mp="x9ur5oc5w29d">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[-120px] h-[380px] w-[560px] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(242,196,107,0.2),rgba(47,107,255,0.1)_60%,transparent)]" data-id="element-105" data-mp="s9zybf8tt2lo" />

      <SectionTitle id="hero-title" as="h1" tone="dark" title={hero.title} highlight={hero.highlight} className="relative order-1" data-id="element-106" data-mp="3cz5uuafyvxzt" />

      <p className="relative order-4 mx-auto mt-8 max-w-xl leading-relaxed text-white/85 sm:order-2 sm:mt-5 sm:text-[17px]" data-id="element-107" data-mp="3j7zc59vbxccg">
        {hero.text}
      </p>
      <Punchline text={hero.punchline} tone="dark" className="relative order-5 mt-4 sm:order-3" data-id="element-108" data-mp="3o5j39ad4ljlt" />

      <ProductMockup size="lg" eager className="order-2 mt-3 sm:order-4 sm:mt-8" data-id="element-109" data-mp="39cfjqxfz4vsg" />

      <div className="relative order-3 mx-auto mt-4 w-full max-w-md sm:order-5 sm:mt-8" data-id="element-110" data-mp="3e7uzjuxjl1ri">
        <BuyButton id="hero-cta" label={hero.cta} href={hero.ctaHref} data-id="element-111" data-mp="30ggdff8c8kg8" />
        <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.08em] text-white/90" data-id="element-112" data-mp="358zq89z7bbjz">
          {hero.finePrint}
        </p>
        <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-113" data-mp="2qlofuber9xlg">
          {hero.pills.map(pill => <Pill key={pill.label} icon={pill.icon} label={pill.label} data-id="element-114" data-mp="2vjg5eyrxh7mh" />)}
        </div>
      </div>

      <Wave fill={surface.white} data-id="element-115" data-mp="2hjoz7k7nkvj1" />
    </header>;
}